module.exports = __webpack_public_path__ + "img/remaining-days.ae81dde6.png";